import { AppState } from 'src/app/store'

export const summaryBalanceSelector = (state: AppState) => state.summary.balance
export const summaryChartFilterSelector = (state: AppState) => state.summary.filter
export const summarySalesDataSelector = (state: AppState) => state.summary.salesData
export const summaryOrdersDataSelector = (state: AppState) => state.summary.ordersData
export const summaryWithdrawSelector = (state: AppState) => state.summary.withdraw
export const summaryDepositSelector = (state: AppState) => state.summary.deposit
